import React from 'react';

/** Round icon-only button — replaces MUI IconButton. */
const SIZES = { xs: 'h-6 w-6', sm: 'h-8 w-8', md: 'h-9 w-9' };

const IconButton = React.forwardRef(
  ({ children, size = 'sm', title, className = '', type = 'button', ...rest }, ref) => (
    <button
      ref={ref}
      type={type}
      title={title}
      className={`inline-flex flex-shrink-0 items-center justify-center rounded-full text-[#637381] transition-colors hover:bg-slate-100 hover:text-[#212B36] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2e9e2e]/30 disabled:cursor-not-allowed disabled:opacity-40 ${
        SIZES[size === 'small' ? 'sm' : size] || SIZES.sm
      } ${className}`}
      {...rest}
    >
      {children}
    </button>
  )
);

IconButton.displayName = 'IconButton';
export default IconButton;
